<template lang="pug">
	.v-info-section.info-section(v-if="banner")
		.info-section__container.container
			.info-section__wrap
				.info-section__left
					.info-section__info-wrap
						template(v-if="!isLg")
								img.info-section__image.info-section__image--visible(:src="banner.image" alt="")
				.info-section__right.flc(:ref="'item'" :class="[banner.colorOption ? `info-section__item--${banner.colorOption}` : '']")
					img.info-section__image(v-if="isLg" :src="banner.imageMob" alt="")
					.info-section__item-header
						.info-section__item-title-wrap
							h3.info-section__item-title(v-if="banner.title" v-html="banner.title")
							.info-section__item-icon-wrap
								v-svg-icon.info-section__item-icon(:icon="banner.icon")
						.info-section__content
							.info-section__item-text(v-if="banner.text" v-html="banner.text")
							ul.info-section__item-list(v-if="banner.items && banner.items.length"
								:class="{'info-section__item-list--has-many-items': banner.items.length > 3}")
								template(v-for="(itemLvl2, itemLvl2Index) in banner.items" :key="itemLvl2Index")
									li.info-section__item-lvl2
										.info-section__item-lvl2-title(v-if="itemLvl2.title") {{itemLvl2.title}}
										.info-section__item-lvl2-text(v-if="itemLvl2.text" v-html="itemLvl2.text")
							.info-section__item-action
								a.info-section__item-btn.btn.btn--has-right-icon.btn--primary.btn--alt-hover(v-if="banner.link" :href="banner.link.link")
									.btn__text {{banner.link.text}}
									.btn__icon-wrap
										v-svg-icon.btn__icon.btn__icon--original(icon="arrow-top-right")
										v-svg-icon.btn__icon.btn__icon--copy(icon="arrow-top-right")
					//.info-section__item.info-section__item--dummy(v-if="!isLg")
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';
import controller from "../scripts/controller/controller.js";

export default {
	mixins: [
		sourceMixin,
		isMobMixin
	],

	data() {
		return {
			banner: null,
			activeIndex: 0,
			activeImage: this.banner?.items[0].image,
			itemHeaderHeight: 16
		};
	},

	unmounted() {
		// window.removeEventListener('scroll', this.handleScroll);
	},

	methods: {
		// handleScroll() {
		// 	const logoHeight = 80;
		// 	const logoOffset = 48;
		// 	if (window.scrollY > this.$el.offsetTop - 48 && (window.scrollY < this.$el.offsetHeight + this.$el.offsetTop + logoHeight - logoOffset)) {
		// 		document.body.classList.remove('state--page-header-blackout');
		// 		let $currentItem = this.$refs['item'];
		// 		if ($currentItem) {
		// 			if (this.$el.offsetTop + $currentItem[0].offsetTop - window.scrollY - window.innerHeight + (window.innerHeight / 3) < 0) {
		// 				this.activeIndex = index;
		// 			}
		// 		}
		// 	}
		// },

		dataSet(data) {
			this.banner = data;
			// this.handleScroll();
			// window.addEventListener('scroll', this.handleScroll, controller.passiveEventsSupported ? {passive: true} : undefined);
		}
	}
};
</script>
